"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState, useRef } from "react";
import Spinner from "../Spinner";

export default function LocaleChangeLoader({ locale }: { locale: string }) {
  const pathname = usePathname();
  const previousLocale = useRef(locale);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // locale changed? (e.g. /en/... → /fr/...)
    if (previousLocale.current !== locale) {
      setLoading(true);

      // small delay so loader appears cleanly
      const timeout = setTimeout(() => setLoading(false), 600);

      previousLocale.current = locale;
      return () => clearTimeout(timeout);
    }
  }, [locale, pathname]);

  if (!loading) return null;

  return (
    <Spinner loading={true} timer={5000}><></></Spinner>
  );
}
